/**
 * Cart Quantity Reminder Component
 * 当购物车商品数 >= 2 时显示简单提醒弹窗
 * 确认后当前会话不再弹出
 */

class CartQuantityReminder {
  constructor() {
    this.modal = document.getElementById('cart-quantity-reminder-modal');
    if (!this.modal) return;

    this.itemCountEl = document.getElementById('reminder-item-count');
    this.confirmBtn = document.getElementById('reminder-confirm-btn');

    // 确认一次后当前会话不再弹出
    this.hasConfirmed = false;

    this.bindEvents();
    this.subscribeToCartUpdates();
  }

  /**
   * 绑定按钮事件
   */
  bindEvents() {
    if (this.confirmBtn) {
      this.confirmBtn.addEventListener('click', () => this.onConfirm());
    }
  }

  /**
   * 订阅购物车更新事件
   */
  subscribeToCartUpdates() {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData) {
          this.checkAndShowReminder(event.cartData);
        }
      });
    }
  }

  /**
   * 检查购物车并在需要时显示提醒
   * 仅统计"主商品"件数，跳过依附性保护计划（properties._protection_for_id 不为空）
   * @param {Object} cartData - 购物车数据
   */
  checkAndShowReminder(cartData) {
    if (!cartData || this.hasConfirmed) return;

    // Preferred: caller pre-computed main-only count via Liquid (most reliable
    // — no JSON parsing surprises around `item.properties` shape).
    if (typeof cartData.initialMainCount === 'number') {
      if (cartData.initialMainCount >= 2) this.show(cartData.initialMainCount);
      return;
    }

    if (cartData.items && Array.isArray(cartData.items)) {
      var hasPropertiesField = cartData.items.some(function (it) {
        return Object.prototype.hasOwnProperty.call(it, 'properties');
      });

      if (hasPropertiesField || cartData.items.length === 0) {
        var itemCount = 0;
        for (var i = 0; i < cartData.items.length; i++) {
          var item = cartData.items[i];
          if (item.properties && item.properties._protection_for_id) continue;
          itemCount += item.quantity || 1;
        }
        if (itemCount >= 2) this.show(itemCount);
        return;
      }
    }

    // Fallback: 数据缺少 properties 字段（如只传了 item_count），从 /cart.js 拉取完整购物车再过滤
    var self = this;
    var cartUrl = (typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url : '/cart') + '.js';
    fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (full) {
        if (self.hasConfirmed || !full || !Array.isArray(full.items)) return;
        var count = 0;
        for (var j = 0; j < full.items.length; j++) {
          var it = full.items[j];
          if (it.properties && it.properties._protection_for_id) continue;
          count += it.quantity || 1;
        }
        if (count >= 2) self.show(count);
      })
      .catch(function () { /* 静默失败，不打扰用户 */ });
  }

  /**
   * 显示提醒弹窗
   * @param {number} itemCount - 商品数量
   */
  show(itemCount) {
    if (!this.modal) return;

    // 更新显示的商品数量
    if (this.itemCountEl) {
      this.itemCountEl.textContent = itemCount;
    }

    // 显示弹窗
    this.modal.removeAttribute('hidden');
    document.body.classList.add('cart-reminder-open');

    // 聚焦到确认按钮
    if (this.confirmBtn) {
      this.confirmBtn.focus();
    }

    // 设置焦点陷阱
    this.trapFocus();
  }

  /**
   * 隐藏弹窗
   */
  hide() {
    if (!this.modal) return;

    this.modal.setAttribute('hidden', '');
    document.body.classList.remove('cart-reminder-open');
  }

  /**
   * 用户点击确认
   */
  onConfirm() {
    this.hasConfirmed = true;
    this.hide();
  }

  /**
   * 焦点陷阱 - 确保焦点不会离开弹窗
   */
  trapFocus() {
    var self = this;
    var focusableElements = this.modal.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length === 0) return;

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    this.modal.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
      // ESC 键禁用 - 必须点击按钮确认
    });
  }
}

// 页面加载后初始化
document.addEventListener('DOMContentLoaded', function() {
  if (!window.cartQuantityReminder) { window.cartQuantityReminder = new CartQuantityReminder(); }
});

// 如果页面已加载，立即初始化
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  if (!window.cartQuantityReminder) { window.cartQuantityReminder = new CartQuantityReminder(); }
}
